import React from 'react';

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

import { muiThemeLuma } from 'themes';

interface Props extends SvgIconProps {
  fill: string;
}

const IconFileManagement: React.FC<Props> = ({ fill, ...other }) => (
  <SvgIcon width="16" height="16" viewBox="0 0 16 16" {...other}>
    <path
      d="M2.66671 3.99998H1.33337V13.3333C1.33337 14.0666 1.93337 14.6666 2.66671 14.6666H12V13.3333H2.66671V3.99998ZM13.3334 1.33331H5.33337C4.60004 1.33331 4.00004 1.93331 4.00004 2.66665V10.6666C4.00004 11.4 4.60004 12 5.33337 12H13.3334C14.0667 12 14.6667 11.4 14.6667 10.6666V2.66665C14.6667 1.93331 14.0667 1.33331 13.3334 1.33331ZM12.6667 7.33331H6.00004V5.99998H12.6667V7.33331ZM10 9.99998H6.00004V8.66665H10V9.99998ZM12.6667 4.66665H6.00004V3.33331H12.6667V4.66665Z"
      fill={fill || muiThemeLuma.palette.primary.main}
    />
  </SvgIcon>
);

export default IconFileManagement;
